import createIcon from '../../createIcon';

/**
 * @component @name SouthEast
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSA5LjVIMTcuNVYxNi4wOUw1LjkxIDQuNUw0LjUgNS45MUwxNi4wOSAxNy41SDkuNVYxOS41SDE5LjVWOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SouthEast = createIcon('SouthEast', [
  [
    'path',
    { d: 'M19.5 9.5H17.5V16.09L5.91 4.5L4.5 5.91L16.09 17.5H9.5V19.5H19.5V9.5Z', key: 'sb4c9c' },
  ],
]);

export default SouthEast;
